import { BrandConfigByCode } from "@constants/common";
import { ContentItem } from "@typed/content";

export const GetProductContent = (product: Queries.ProductDetailPageFragment) : ContentItem[] => {
    const toRet : ContentItem[] = [];
    const brandCode = product.brand.code;

    toRet.push({ id: 'european-disposal-info',
        slug: '/european-waste-stream-information',
        type: 'health-and-safety',
        title: 'European Waste Stream Information',
        description: 'Information on how to dispose of this product in Europe'});


    if( brandCode )
    {
        toRet.push({ id: 'sds',
        slug: `/resources/category/${BrandConfigByCode[product.brand.code].slug}-sds`,
        type: 'health-and-safety',
        title: `All ${BrandConfigByCode[product.brand.code].fullName} SDS`,
        description: `Latest safety data sheets for all ${BrandConfigByCode[product.brand.code].fullName} products`});   
        }

    return toRet;

}